import { Status } from "core/models/error";
import { usePartners } from "features/partners/fabric";
import { useStart } from "features/start/fabric";

import { useMutateAuth0, useMutatePartner, useQuerySignup, useQuerySignupPermission } from "areas/partners/data";


const features = [
	{
		head: "For Editors",
		title: "Drive Up Engagement",
		list: ["Increase in Engagement", "No change in workflow", "Happy reporters", "Access other papers for free"]
	},
	{
		head: "For Revenue Officers",
		title: "More Reader Revenue",
		list: ["New source of direct revenue", "Restores Single-Copy sales revenue", "Increases ARPU for non-subs", "You set the price, not us!"]
	},
	{
		head: "For Business Leaders",
		title: "Grow Your Business",
		list: ["No cost to you", "No credit card fees", "Pays more than Apple or Google", "You make almost 80%!"]
	},
	{
		head: "For Marketing Teams",
		title: "Your Brand - Your Message",
		list: ["Readers stay on your site and app", "No Apple and Google News traffic loss", "New promotion opportunities", "Subly fits into your design"]
	},
	{
		head: "For Circulation Managers",
		title: "Stop Trial Pricing",
		list: ["Add per-article circulation", "One-click Day Pass sales", "Stop giving away samples", "Stop trial cancellations"]
	},
	{
		head: "For IT Teams",
		title: "Simple Integration",
		list: ["One-hour integration", "Supports popular CMS + Paywall", "Easy Copy/Paste guide", "Test deployments and transactions", "No SaaS costs"]
	}
];

const passes = [
	{ value: 1, label: "Day Pass" },
	{ value: 7, label: "Week Pass" }
];

export const usePartnerInterest = () => {
	const partner = usePartners();

	const subscribe = {
		title: "Stop leaving money at the paywall.",
		description:	"Become a Subly® partner and gain three things from day one:",
		list: [
			"A new incremental revenue stream: Earn on reads that are currently worth zero — from readers your paywall was already turning away.",
			"Improved ad revenue: More readers completing full articles means more ad impressions and higher engagement metrics.",
			"A stronger subscriber pipeline: Micropayment readers are now in your funnel. A subscription commitment is the natural next step."
		],
		action: "Learn more",
		to: "https://go.subly.ink"
	};

	return { ...partner, features, subscribe };
};

export const usePartnerSignup = () => {
	const partner = useMutatePartner();
	const query = useQuerySignup();
	const auth0Mutation = useMutateAuth0();
	const permission = useQuerySignupPermission();
	const start = useStart();
	const data = query.data;

	const step = {
		validate: data?.emailVerified,
		approved: data?.status === "Approved"
	};

	const current = (() => {
		if (step.approved || step.validate) return 2;
		return 1;
	})();

	const disabled = !permission.isPending && !permission.data?.partner;

	const resend = () => auth0Mutation.mutate({ partnerId: data.id, email: data.profile.email, name: data.profile.name, userId: start.user.id });

	const isServerError = partner.error?.type === Status[500];

	const auth0 = {
		resend,
		isPending: auth0Mutation.isPending
	};

	return { ...partner, auth0, current, disabled, isServerError, query, features, passes, step };
};